document.addEventListener('DOMContentLoaded', () => {
  const breakpoint = 768; // mobile cutoff
  let swipers = [];

  function initMobileSwipers() {
    document.querySelectorAll('.product-compare__container .swiper').forEach((el, index) => {
      // prevent duplicate init
      if (el.classList.contains('swiper-initialized')) return;
      const section = el.closest('.product-compare__container');
      const swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 5,
        loop: false,
        draggable: true,
        scrollbar: {
            el: section.querySelector('.swiper-scrollbar'),
            draggable: true
        },
        navigation: {
            nextEl: section.querySelector('.swiper-arrow--next'),
            prevEl: section.querySelector('.swiper-arrow--prev')
        },
      });

      swipers.push(swiper);
    });
  }

  function destroySwipers() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
    });
    swipers = [];
  }

  function handleResize() {
    if (window.innerWidth < breakpoint) {
      initMobileSwipers();
    } else {
      destroySwipers();
    }
  }

  // initial run
  handleResize();

  // on resize
  window.addEventListener('resize', handleResize);
});